export const alertsConfig = [
  {
    key: "mortality",
    label: "Deceased Check",
    type: "dataCount",
    fieldName: "ItemsCurrentAddressMortalityHALO",
    tooltip: "Mortality checks provide details of individuals who are deceased, these are compiled from trusted data sources to identify individuals that are not present on other commercial data sources.",
  },
  // {
  //   key: "fraud",
  //   label: "Potential Fraud Alert",
  //   type: "orchestratorDecision",
  //   tooltip:
  //     "Potential Fraud Alert checks have found a area of concern relating to the information provided on the individual.",
  // },
];
